<template>
  <div
    class="rossetto-video"
    @mouseover="$_updateCursorOnPlayerStatus"
    @mouseout="updateMouseCursor('default')">
    <div
      v-if="typeof player !== 'undefined'"
      class="rossetto-video__fake-overlay"
      @click="$_playPause">
      <div
        v-if="!playing"
        class="rossetto-video__fake-overlay--play"><span>Play</span></div>

      <div
        v-else
        class="rossetto-video__fake-overlay--pause"><span>PAUSE</span></div>
    </div>

    <div
      v-video="playerOptions"
      class="rossetto-video__video"></div>
  </div>
</template>

<script>
import YouTubePlayer from 'youtube-player'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data: () => ({
    player: undefined,
    playing: false,
    statuses: {
      PLAYING: 1
    }
  }),
  props: {
    videoId: {
      type: String,
      default: 'tlTKTTt47WE'
    }
  },
  computed: {
    ...mapGetters('animations', [
      'mouseCursor'
    ]),
    playerOptions: {
      get () {
        return {
          videoId: this.videoId,
          playerVars: {
            autoplay: 0,
            controls: 0,
            fs: 0,
            modestbranding: 1,
            rel: 0,
            showinfo: 0
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ]),
    async $_updateCursorOnPlayerStatus () {
      if (await this.player.getPlayerState() === this.statuses.PLAYING) this.updateMouseCursor('video--playing')
      else this.updateMouseCursor('video')
    },
    async $_playPause () {
      if (await this.player.getPlayerState() !== this.statuses.PLAYING) this.player.playVideo()
      else this.player.pauseVideo()
    },
    async $_refreshCursor ({ data }) {
      if (this.mouseCursor === 'video' && await this.player.getPlayerState() === this.statuses.PLAYING) this.updateMouseCursor('video--playing')
      if (this.mouseCursor === 'video--playing' && await this.player.getPlayerState() !== this.statuses.PLAYING) this.updateMouseCursor('video')
    },
    async $_refreshMobileButtons () {
      this.playing = await this.player.getPlayerState() === this.statuses.PLAYING
    }
  },
  directives: {
    video: {
      bind (el, binding, vnode) {
        vnode.context.$data.player = YouTubePlayer(el, binding.value)
        vnode.context.$data.player.on('stateChange', vnode.context.$_refreshCursor)
        vnode.context.$data.player.on('stateChange', vnode.context.$_refreshMobileButtons)
      },
      unbind (el, binding, vnode) {
        // TODO: update
        vnode.context.$data.player.destroy()
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';

.rossetto-video {
  margin: 140px 0 170px 0;
  padding-bottom: 42%;
  width: 100%;
  position: relative;
  height: 0;

  iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    padding-bottom: 50%;
  }
}

.rossetto-video__fake-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rossetto-video__fake-overlay--play, .rossetto-video__fake-overlay--pause {
  background: white;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  @include media(">=large") {
    display: none;
  }
}

.rossetto-video__fake-overlay--pause {
  display: none;
}
</style>
